exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-audiochat-window{width:620px;height:500px}#asseco-audiochat-window .mdl-layout__content{height:100%}@media only screen and (max-width:1024px){#asseco-audiochat-window{width:320px}}@media only screen and (max-width:690px),screen and (max-height:510px){#asseco-audiochat-window{width:100%!important;height:100%!important;position:fixed!important;top:0;left:0}}", ""]);

// exports
